export default __webpack_public_path__ + "static/media/bg-login-page-dark.e6429241.svg";